(async() => {
    const { Core } = await importModule('Core');
    const {
        $JSON,
        cache,
        $fetch
    } = await importModule('Utils');

    const CACHE_KEY = 'variant-provider';

    function elementsToMap(elements) {
        return elements.reduce((acc, element) => {
            if (element.id) {
                acc[element.id] = element.cloneNode(true);
            }
            return acc;
        }, {});
    }

    class OptionsHistory {
        constructor(limit) {
            this.limit = limit;
            this.items = Array.from(Array(limit).keys());
        }
        add(item) {
            if(this.lastItem === item) {
                return;
            }
       
            const index = this.items.indexOf(item);
            this.items.splice(index, 1);
            this.items.push(item);
            // sanity chech
            if (this.items.length > this.limit) {
                this.items.shift();
            }
        }
        get lastItem() {
            return this.items.at(-1);
        }

        getValidOption(options) {
            for (const optionIndex of this.items) {
                // If matching option index comes from the last item, it means selection 
                // from other(previous) options failed to find it, hence the next selection 
                // will not include a variant with the last item option id
                if(options[optionIndex] && this.lastItem !== optionIndex) {
                    return {
                        ...options[optionIndex],
                        optionIndex
                    }
                }
            }
            return null;
        }
    }

    customElements.define('product-variant-provider', class extends Core {
        elements = {
            productMeta: '[data-product-meta]',
            listeners: '*product-variant-listener'
        }

        subscriptions = {
            'selling-plan:change': '_onSellingPlanChange',
            'variant:change': '_changeVariant',
        }

        render() {
            this.smartSelect = !this.hasAttribute('allow-unavailable-variants');
            this.disableCache = this.hasAttribute('no-cache');
            this.subscribe('variant:change');
            this.subscribe('selling-plan:change');
            this._initState();
        }

        async _initState() {
            this.currentState = { 
                variantId: this.initialVariantId,
                optionValueIds: this.initialOptionsState.split(','),
                variantImagePosition: this.initialImagePosition,
                sellingPlanId: this.initialSellingPlan
            };
            if (this.smartSelect) {
                this.optionsHistory = new OptionsHistory(this.currentState.optionValueIds.length);
            }
            this._initCache();
        }

        _initCache() {
            if(this.disableCache) {
                return;
            }
            if (!cache.has(this._cacheKey)) {
                cache.set(this._cacheKey, {
                    listeners: elementsToMap(this.$listeners)
                });
                return;
            }
            // if we have cache on initilization it's mean this cache was initited by someone before
            // refresh contents on the next tick
            setTimeout(() => {
                this._publishUpdates();
            }, 20)
        }

        _changeVariant({ optionValueId, optionIndex, variantId, imagePosition }) {       
            // custom js
            
            const productData = JSON.parse(document.getElementById('product-data').textContent); 
            const variant = productData.variants.find(v => v.id == variantId);
            const media_gallery = document.querySelectorAll('.cstm-media-el')

                 let matchFound = false;

            media_gallery.forEach(m => {
                // Log the media element for debugging
                // console.log(m);

                // Check if the media has `data-variant-id` (this indicates a custom variant)
                const variantIdInMedia = m.getAttribute('data-variant-id');
                const isDefaultVariant = m.hasAttribute('default-variants');  // For default-variants check

                // When a match is found (variantId is defined):
                if (variantId) {
                    // If the media has `data-variant-id` (custom variant images)
                    if (variantIdInMedia) {
                        // If the variantId matches the selected variant, remove hideMedia
                        if (variantIdInMedia === variantId) {
                            m.classList.remove('hideMedia'); // Show matching variant
                            matchFound = true;  // A match has been found
                        } else {
                            m.classList.add('hideMedia'); // Hide non-matching variant
                        }
                    }

                    // **Add hideMedia to all default-variants images** when a match is found
                    if (isDefaultVariant) {
                        m.classList.add('hideMedia'); // Hide all default images
                    }
                }
            });
            const productVariantProviderElement = document.querySelector('product-gallery');

            // When no match is found (variantId is not found or no match for any variant):
            if (!matchFound) {
    media_gallery.forEach(m => {
        if (m.hasAttribute('default-variants')) {
            m.classList.remove('hideMedia');
            if (productVariantProviderElement) {
                productVariantProviderElement.classList.remove('custom-variant-images');
            }
        } else if (m.getAttribute('data-variant-id')) {
            m.classList.add('hideMedia');
        }
    });
}

if (!matchFound) {
    media_gallery.forEach(m => {
        if (m.hasAttribute('default-variants')) {
            m.classList.remove('hideMedia');
            if (productVariantProviderElement) {
                productVariantProviderElement.classList.remove('custom-variant-images');
            }
        } else if (m.getAttribute('data-variant-id')) {
            m.classList.add('hideMedia');
        }
    });
}
this.setAttribute('data-images-ready', 'true');

             // Update the data-image-position attribute based on matchFound
                // console.log("product-gallery",productVariantProviderElement);
                if (productVariantProviderElement) {
                    productVariantProviderElement.setAttribute('data-image-position', matchFound ? 'true' : 'false');
                   
                //  console.log("Attr Added gallery",productVariantProviderElement);

                }


             if (matchFound) {
                setTimeout(() => {
                    // Select the first visible custom variant (with data-variant-id)
                    const firstMatchedMedia = document.querySelector('.cstm-media-el:not(.hideMedia)');
                     if (productVariantProviderElement) {
                     productVariantProviderElement.classList.add('custom-variant-images'); 
                     }
                    // If we find a matched media, trigger a click event
                    if (firstMatchedMedia) {
                        firstMatchedMedia.click(); // Trigger a click on the first matched element
                        this.setAttribute('data-images-ready', 'true');
                        // console.log("First matched media clicked");
                    }
                }, 50); // Set the delay (in milliseconds) for when to trigger the click
            }
            if(document.getElementById('prd-temp-attr')){
            const findelmattr = document.getElementById('prd-temp-attr')
            const check_template = findelmattr.getAttribute('data-template')
            const cstm_title = document.querySelector('.cstm-prd-title');
            if(check_template == 'physical-book'){
            const cstmDescription = document.querySelector('.cstm-description') 

           
            const description = variant.description || "Not Available";
            const variant_title = variant.variant_title || null
            if(variant_title != null){
              cstm_title.textContent = variant_title
            }
            cstmDescription.innerHTML = description;
            }  
            } 
            if(document.getElementById('featured-prd-attr')){
                const featured_product_data = JSON.parse(document.getElementById('featured_product_data').textContent); 
                const featured_product_variant = featured_product_data.variants.find(v => v.id == variantId);
                const featured_title = document.querySelector('.featured-prd-h1');
                const featured_description = document.querySelector('.featured_descr');
                  
                const f_description = featured_product_variant.description || null;
                const f_variant_title = featured_product_variant.variant_title || null
                if(f_variant_title != null){
                featured_title.textContent = f_variant_title
                }
                if(f_description != null){
                featured_description.innerHTML = f_description;
                }

            }
            //end js
            this.currentState.optionValueIds[+optionIndex] = optionValueId;        
            this.currentState.variantId = variantId || undefined;
            this.currentState.variantImagePosition = imagePosition;
            
            this.optionsHistory?.add(+optionIndex);
            this._handleUpdate();
        }

        async _handleUpdate() {
            await this._updateCache();
            this._publishUpdates();
            this._updateProps();
            if (this.isProductPage) {
                this._updateBrowserHistory();
            }
        }

        async _updateCache() {
            if (cache.has(this._cacheKey) && !this.disableCache) return;
            const $listeners = await this._fetchDoc();
            if($listeners) {
                cache.set(this._cacheKey, {
                    listeners: elementsToMap($listeners),
                });
            }
        }

        _updateProps() {
            this.setAttribute('initial-variant-id', this.currentState.variantId);
            this.setAttribute('initial-image-position', this.currentState.variantImagePosition);
            this.setAttribute('initial-selling-plan', this.currentState.sellingPlanId);
        }

        _publishUpdates() {
            if(cache.has(this._cacheKey)) {
                this.publish('variant:update', {
                    imagePosition: this.currentState.variantImagePosition,
                    targets: cache.get(this._cacheKey).listeners      
                })
            }
        }

        get _cacheKey() {
            return `${CACHE_KEY}-${this.sectionId}-${this.currentState.variantId}-${this.optionValueIdsString}-${this.currentState.sellingPlanId}`;
        }

        get optionValueIdsString() {
            return this.currentState.optionValueIds.toString();
        }

        async _fetchDoc() {
            const $doc = await $fetch(this.productURL, {
                before: this._loading(true),
                after: this._loading(false),
                params: {
                    selling_plan: this.currentState.sellingPlanId,
                    section_id: this.sectionId,
                    option_values: this.optionValueIdsString,
                },
                select: `#${this.id}`
            })

            if (this.smartSelect && !this.currentState.variantId) {
                const $availableOptionsJSON = $doc.querySelector('[data-available-options-json]'); 
                if (this._smartSelectVariant($availableOptionsJSON)) {    
                    // We will get a doc from the next _fetch iteration initiated by smart select
                    return null;
                } 
            }             
            return this._getListenersFromDoc($doc);
        }


        _getListenersFromDoc($doc) {
            return Array.from($doc.querySelectorAll('product-variant-listener'));
        }

        _loading(state) {
            return () => {
                this.publish('variant:loading', state);
            }
        }

        _smartSelectVariant(optionsJSON) {
            if(!optionsJSON) {
                console.error('JSON schema for smart select variants is missing');
                return false;
            }

            let options;
            try {
                options = $JSON(optionsJSON);
            } catch (e) {
                console.error(e);
                return false;
            }

            const matchOption = this.optionsHistory.getValidOption(options);

            if(!matchOption) {
                return false;
            }

            this._changeVariant(matchOption)
            return true;

        }

        _updateBrowserHistory() {
            window.history.replaceState({}, null, `${window.location.pathname}?${this.browserHistoryURLParams.toString()}`);
        }

        _onSellingPlanChange({ sellingPlanId }) {
            this.currentState.sellingPlanId = sellingPlanId;
            this._handleUpdate();
        }

        get browserHistoryURLParams() {
            const URLParams = new URLSearchParams({});
            if (this.currentState.variantId) {
                URLParams.set('variant', this.currentState.variantId);
            }
            // if (!this.currentState.variantId) { //NOTE: leave this here for now. The Dawn avoids this.
            //     URLParams.set('option_values', this.optionValueIdsString);
            // }
            this.currentState.sellingPlanId ? URLParams.set('selling_plan', this.currentState.sellingPlanId) : URLParams.delete('selling_plan');
            return new URLSearchParams(URLParams);
        }

        get isProductPage() {
            return this.hasAttribute('product-page');
        }
        get productURL() {
            return this.getAttribute('product-url');
        }
        get initialVariantId() {
            return this.getAttribute('initial-variant-id');
        }
        get initialImagePosition() {
            return this.getAttribute('initial-image-position');
        }
        get initialSellingPlan() {
            return this.getAttribute('initial-selling-plan');
        }
        get initialOptionsState() {
            return this.getAttribute('initial-options-state');
        }

    });
})()